import { ConfirmFormModalComponent } from './confirm-form-modal.component';
import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui";
import { IConfirmFormModalContext } from '../../core/models/confirmFormModal.interface';

export class ConfirmFormModal extends ComponentModalConfig<IConfirmFormModalContext, void, void> {
    constructor(title:string, input: string, errorTitle: string, errorMessage: string, size = ModalSize.Small) {
        super(ConfirmFormModalComponent, { title , input, errorTitle, errorMessage});
        this.isClosable = false;
        this.transitionDuration = 200;
        this.size = size;
    }
}